
import React from 'react'
import PropTypes from 'prop-types'
import { getCdnAssetUrl } from 'utils/server-data'

function PayPalLogo({ height = '30px', style = {}, className = '', overlay = true, ...props }) {
  const defaultStyle = overlay ? {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 0',
    ...style
  } : {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '50px',
    ...style
  }

  return (
    <div style={defaultStyle} className={className}>
      <img
        src={getCdnAssetUrl('paypal-ui/logos/svg/paypal-mark-color.svg')}
        alt="PayPal Logo"
        style={{ height }}
        {...props}
      />
    </div>
  )
}

PayPalLogo.propTypes = {
  height: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  overlay: PropTypes.bool,
}

export default PayPalLogo